import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { BaseInputProps } from "../types/componentTypes";

interface PasswordInputProps extends BaseInputProps {}

const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  disabled,
  required,
  error,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="mb-4 max-w-lg">
      {label && (
        <label htmlFor={props.name} className="block text-sm font-bold mb-1">
          {label}
        </label>
      )}
      <div className="relative">
        <div className="flex items-center">
          <input
            type={showPassword ? "text" : "password"}
            id={props.name}
            {...props}
            className={`w-full pr-14 py-2 px-3 rounded-lg bg-gray-100 focus:outline-none focus:ring-2 ${
              error ? "border-red-500" : ""
            }`}
            disabled={disabled}
            required={required}
          />
          <button
            type="button"
            className="absolute inset-y-0 right-0 flex items-center px-3"
            onClick={togglePasswordVisibility}
            disabled={disabled}
          >
            {showPassword ? (
              <FaEyeSlash className="text-gray-500" />
            ) : (
              <FaEye className="h-6 w-6 text-gray-500" />
            )}
          </button>
        </div>
      </div>
      {error && <div className="text-red-500 text-xs mt-1">{error}</div>}
    </div>
  );
};

export default PasswordInput;
